import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Drawer,
} from '@makeably/creativex-design-system';
import { optionArrayProps } from 'components/internal/shared';
import styles from './OptionsDrawer.module.css';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  options: optionArrayProps.isRequired,
};

function OptionsDrawer({
  isOpen,
  options,
  onClose,
}) {
  return (
    <Drawer isOpen={isOpen} onClose={onClose}>
      <div className={styles.drawer}>
        <div className={`u-scrollShadowBottom ${styles.scrollable}`}>
          { options.map((option) => (
            <div key={option.value}>{ option.label }</div>
          )) }
        </div>
        <div className={styles.buttons}>
          <Button
            label="Close"
            onClick={onClose}
          />
        </div>
      </div>
    </Drawer>
  );
}

OptionsDrawer.propTypes = propTypes;

export default OptionsDrawer;
